export default __webpack_public_path__ + "static/media/pharmaCase.034c14c6.jpg";